export const isNumeric = (value: unknown): boolean =>
  value !== true &&
  value !== false &&
  typeof value !== 'bigint' &&
  typeof value !== 'symbol' &&
  !isNaN(parseFloat(value as string)) &&
  isFinite(value as number);

export const isInt = (value: any): boolean => Number.isInteger(+value);
